import React from 'react';
import { PhotoIcon, DocumentIcon } from '@heroicons/react/24/outline';

const ResolutionDetailsTab = ({ complaint }) => {
  const getFeedback = () => {
    return complaint?.feedback || null;
  };

  const getFeedbackAttachments = () => {
    const feedback = getFeedback();
    if (!feedback) return [];

    if (feedback.file_url && Array.isArray(feedback.file_url) && feedback.file_url.length > 0) {
      return feedback.file_url.map((url, index) => ({
        file_url: url,
        file_name: url.split('/').pop() || `feedback-attachment-${index + 1}`,
        file_type: url.split('.').pop()?.toLowerCase() || 'unknown',
      }));
    }

    if (feedback.file_path && Array.isArray(feedback.file_path) && feedback.file_path.length > 0) {
      return feedback.file_path.map((path, index) => ({
        file_url: path,
        file_name: path.split('/').pop() || `feedback-attachment-${index + 1}`,
        file_type: path.split('.').pop()?.toLowerCase() || 'unknown',
      }));
    }

    return [];
  };

  const getFileIcon = (fileType) => {
    const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
    const docTypes = ['pdf', 'doc', 'docx', 'txt', 'xls', 'xlsx'];

    if (imageTypes.includes(fileType)) {
      return <PhotoIcon className="h-5 w-5 text-blue-400 mr-2" />;
    }

    if (docTypes.includes(fileType)) {
      return fileType === 'pdf'
        ? <DocumentIcon className="h-5 w-5 text-red-400 mr-2" />
        : <DocumentIcon className="h-5 w-5 text-blue-400 mr-2" />;
    }

    return <DocumentIcon className="h-5 w-5 text-gray-400 mr-2" />;
  };

  const feedback = getFeedback();
  const feedbackAttachments = getFeedbackAttachments();

  return (
    <div className="space-y-6">
      {/* CITIZEN FEEDBACK */}
      <div>


         {/* Resolution Proof */}
        <div className="mb-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Resolution Proof
          </label>

          {feedbackAttachments.length > 0 ? (
            <div className="space-y-2">
              {feedbackAttachments.map((attachment, index) => (
                <a
                  key={`feedback-attachment-${index}`}
                  href={attachment.file_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-sm text-blue-600 underline hover:text-blue-800"
                >
                  {getFileIcon(attachment.file_type)}
                  <span className="truncate">{attachment.file_name}</span>
                </a>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-400">No resolution proof</p>
          )}
        </div>

        {/* Comment = Citizen Feedback (NO BOX) */}
        <div className="mb-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Citizen Feedback
          </label>
          {feedback?.comment ? (
            <p className="text-sm text-gray-900 whitespace-pre-wrap">
              {feedback.comment}
            </p>
          ) : (
            <p className="text-sm text-gray-400">No citizen feedback</p>
          )}
        </div>

        {/* Rating */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Rating
          </label>
          <p className="text-sm text-gray-900">
            {feedback?.rating ? `${feedback.rating}` : 'No rating provided'}
          </p>
        </div>

      </div>
    </div>
  );
};

export default ResolutionDetailsTab;